import axios, { AxiosError, AxiosResponse, Method } from 'axios'

type AllowedResponseTypes = 'json' | 'blob' | 'arraybuffer' | 'text'

export const fetchDataFromApi = async (url: string, token: string, method: Method = 'get', responseType?: AllowedResponseTypes, bodyData?: any) => {
  try {
    const axiosInstance = axios.create()
    axiosInstance.interceptors.request.use(
      (config) => {
        // Füge das Access Token zum Autorisierungs-Header hinzu, wenn es verfügbar ist
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
          config.headers['Content-Type'] = 'application/json'
        }
        return config
      },
      (error: AxiosError) => {
        return error.response
      }
    )

    axiosInstance.interceptors.response.use(
      (response) => {
        return response
      },
      (error: AxiosError) => {
        return error
      }
    )

    const response: AxiosResponse = await axiosInstance.request({
      method: method,
      url: url,
      responseType: responseType,
      data: `${JSON.stringify(bodyData)}`,
    })
    // Überprüfe den HTTP-Statuscode auf Erfolg (2xx)
    return response
  } catch (error) {
    if (import.meta.env.DEV) console.log(error)
    return Promise.reject(error)
  }
}
